/* @flow */

import * as React from 'react';
import styled from 'styled-components';
import Icon from './Icon';

const SearchBox = styled.div`
  display: flex;
  position: relative;
  height: ${({ height }) => height};
  /* bad */
  flex: 0 1 ${({ width }) => width || '130px'};
  ${({ alignRight }) => (alignRight ? 'margin-left: auto;' : '')}
  margin:${({ pro }) => pro ? '0.5em' : '0'};
  & > input {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 2px 10px 0 24px;
    border: 1px solid ${({ theme }) => theme.border1};
    background: ${({ theme }) => theme.inputBg};
    color: inherit;
    outline: 0;
    &:focus {
      border-color: ${({ theme }) => theme.highlight};
    }
  }
  & > i {
    position: absolute;
    left: 6px;
    top: 50%;
    transform: translateY(-50%);
    color: ${({ theme }) => theme.fontColor};
  }
`;

type Props = {
  value?: string,
  placeholder?: string,
  onChange: Function,
  alignRight?: boolean,
  width?: string,
  height?: string,
  pro?: boolean,
};

type State = { value?: string };

export default class SearchInput extends React.PureComponent<Props, State> {
  static defaultProps = {
    value: '',
    placeholder: '',
    alignRight: false,
    width: '',
    height: '22px',
    pro: false,
  };

  state = { value: this.props.value || '' };

  _onChange = (e: KeyboardEvent) => {
    if (!(e.target instanceof HTMLInputElement)) return;
    const val = e.target.value;
    this.setState({
      value: val,
    });
    this.props.onChange(val);
  };

  render() {
    const { value } = this.state;
    const {
      alignRight, placeholder, width, height, pro,
    } = this.props;
    return (
      <SearchBox alignRight={alignRight} width={width} height={height} pro={pro}>
        <Icon type="sousuo" size={14} color="#333" />
        <input id="SearchInput-input-search" type="search" onChange={this._onChange} value={value} placeholder={placeholder} />
      </SearchBox>
    );
  }
}
